(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-mbb-boxes]';
  const REVEAL_SELECTOR = '[data-mbb-reveal]';
  const initialized = new WeakSet();

  function revealImmediately(section) {
    section.querySelectorAll(REVEAL_SELECTOR).forEach((element) => {
      element.classList.add('is-visible');
    });
  }

  function initSection(section) {
    if (!section || initialized.has(section)) return;

    initialized.add(section);

    const elements = [...section.querySelectorAll(REVEAL_SELECTOR)];

    if (!elements.length) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      revealImmediately(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px'
      }
    );

    elements.forEach((element, index) => {
      element.style.setProperty('--mbb-delay', `${index * 80}ms`);
      observer.observe(element);
    });
  }

  function init(scope = document) {
    if (scope.matches?.(SECTION_SELECTOR)) {
      initSection(scope);
    }

    scope.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  }

  function ready() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    event.target
      .closest(REVEAL_SELECTOR)
      ?.classList.add('is-visible');
  });
})();